import { Alert, AutoThemeProvider, Table, Spinner } from '@platform-ui/design-system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser'; 
import $ from 'jquery';

const TenantsTable = (props) => {
    // Table Consts
    const [rows, setRows] = useState([])
    const [rowActions, setRowActions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [noRows, setNoRows] = useState(false);

    // Alert Consts
    const [isAlert, setIsAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertHeader, setAlertHeader] = useState("");
    const [alertBody, setAlertBody] = useState("");

    // NOTE(Xander): In order to ensure the table is reloaded after certain actions, this value can be toggled
    // The reload will happen every time the value is changed, not simply when it is true
    const [reloadTable, setReloadTable] = useState(false);

    // NOTE(Xander): In order to use older Connect modals with the new table, we need to replicate Rails-Ajax functionality
    // This method ensures that all links generated by the table will render their modal on the same page without redirecting
    const ajaxCall = () => {
        $(".MuiList-root a").attr("data-remote",true);
    }

    // NOTE(Michael): this is use to detech when the user is finished typing in the search bar
    const [searchValue, setSearchValue] = useState('')
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchFromBackend(searchValue)
        }, 500)
        if (searchValue.length === 0 && rows.length > 0) {
            setNoRows(false);
        }
        return () => clearTimeout(timer)
    }, [searchValue])

    useEffect(() => {
        getTenants(null);
    }, [reloadTable]);

    const getTenants = async (event) => {
        setLoading(true);
        const URL = props.backend_uri;
        try {
            const options = {
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-type': 'application/json'
                })
            };
            const response = await window.fetch(props.backend_uri, options);
            if (!response.ok) throw Error(response.statusText);
            const data = await response.json();
            setRows(data.rows);
            setRowActions(
                [
                    {
                        icon: 'more_horiz',
                        onClick: getRowActions,
                        listChildren: []
                    }
                ]
            );
            if (data.rows.length === 0) {
                setNoRows(true);
            } else {
                setNoRows(false);
            }
            setLoading(false);
          } catch (error) {
            console.error(error);
            setRows([]);
            setRowActions([]);
            setLoading(false);
            setNoRows(true);
        }
    }

    const apiCall = element => {
        try {
            // NOTE(Xander): This query grabs the rails CSRF token for requests
            let csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            fetch(element.path, {
                method: element.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrf
                }
            }).then((response) => {
                setReloadTable(!reloadTable);
                if (response.status == 200 || response.ok == true) {
                    setAlertHeader("Successfully Performed Action");
                    // setAlertBody("Aren't you a cool guy!");
                    setAlertSeverity("success");
                } else {
                    setAlertHeader(`${response.status}: ${response.statusText}`);
                    setAlertBody("Please Try Again Later");
                    setAlertSeverity("error");
                }
                setIsAlert(true);
                console.log(response);
            }).catch((error) => {
                console.error(error);
            });
        } catch (error) {
            console.error(error);
        }
    }

    const getRowActions = async (event) => {
        try {
            let csrf = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            const options = {
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    'X-CSRF-Token': csrf
                })
            };
            const response = await window.fetch('/admin/tenants/' + event.row.id + '/actions', options);
            if (!response.ok) throw Error(response.statusText);
            const actions = await response.json();
            setRowActions(regenerateRowActions(actions));
        } catch (error) {
            console.error(error)
        }
    }

    function regenerateRowActions(actions) {
        return [
            {
                dsGetActionData: (row) => {
                    var listChildren = []
                    row.actions = actions
                    if (row.actions != null) {
                        var template_link = {}
                        row.actions.forEach((element) => {
                            template_link = {
                                label: element.label
                            };
                            if (element.ajaxCall) {
                                template_link.onClick = ajaxCall
                            }
                            if (element.method === "get") {
                                template_link.href = element.path
                            } else {
                                template_link.onClick = () => {
                                    apiCall(element);
                                }
                            }
                            if (element.disabled) {
                                template_link.disabled = true
                            }
                            listChildren.push(template_link);
                        });
                        return {
                            icon: 'more_horiz',
                            listChildren: listChildren,
                            onClick: getRowActions
                        };
                    }
                }
            }
        ];
    }

    const fetchFromBackend = async (args) => {
        if (args.length != 0){
            setFetching(true);
            if (props.backend_uri.includes("?")){
                var url = props.backend_uri +"&";
                console.log("include query " +props.backend_uri)
            }else{
                var url = props.backend_uri + "?";
                console.log("doesn't includes query")
            }
            
            console.log("We are searching!")
            try {
                const options = {
                    headers: new Headers({
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    })
                };
                const response = await window.fetch(url+new URLSearchParams({
                    sSearch: args, iDisplayLength: 100}), options);
                if (!response.ok) throw Error(response.statusText);
                const data = await response.json();
                var ids = new Set(rows.map(d => d.id));
                var merged = [...rows, ...data.rows.filter(d => !ids.has(d.id))];
                if (data.rows.length === 0) {
                    setNoRows(true);
                }
                setRows(merged);
                setFetching(false);
            } catch (error) {
                console.error(error)
                setFetching(false);
            }
        }
    }

    return (
        <AutoThemeProvider>
            <Alert
                body={alertBody}
                dismissible
                dsOnClose={() => {
                    setIsAlert(false);
                }}
                e2e="tenantAlert"
                header={alertHeader}
                open={isAlert}
                severity={alertSeverity}
            />
            <Table
                loading={loading}
                columns={[
                    {
                        field: 'id',
                        label: 'ID',
                        labelTooltip: 'A unique identifier'
                    },
                    {
                        field: 'name',
                        label: 'Tenant',
                        dsRenderCell: ({row}) => {
                            return <a href={row.tenant_link}>{row.name}</a>
                        }
                    },
                    {
                        field: 'tenant_id',
                        label: 'Tenant ID'
                    },
                    {
                        field: 'global_id',
                        label: 'Global ID'
                    },
                    {
                        field: 'node_id',
                        label: 'Node ID'
                    },
                    {
                        field: 'hostname',
                        label: 'Hostname'
                    },
                    {
                        field: 'slug',
                        label: 'Slug'
                    },
                    {
                        field: 'type',
                        label: 'Type'
                    },
                    {
                        field: 'environment',
                        label: 'Environment'
                    },
                    {
                        field: 'status',
                        label: 'Status'
                    },
                    {
                        field: 'organization',
                        label: 'Organization',
                        dsRenderCell: ({value}) => {
                            return <div> {ReactHtmlParser (value)} </div>
                        }
                    }
                  ]}
                e2e={props.table_name}
                rows={rows}
                uniqueKey={props.table_name}
                searchable
                rowsPerPage={20}
                rowActions={rowActions}
                tableActions={[
                    {
                        icon: "sync",
                        label: "Refresh Tenants",
                        onClick: getTenants,
                    }
                ]}
                orderable={true}
                showNoRowsMessage={noRows}
                dsOnSearchChange={(args) =>  setSearchValue(args)}
            >
            </Table>
            <p style={fetching ? {} : { display: 'none' }}>
                <Spinner variant="linear"/>
                <p>
                    Fetching from the database
                </p>
            </p>
        </AutoThemeProvider>
    );
};

TenantsTable.propTypes = {
    tenants: PropTypes.object
};

export default TenantsTable;